/* eslint-disable no-async-promise-executor */
/* eslint-disable no-unused-vars */
import { isOffline } from '@/services/OfflineMode';
import { _updateRow, _getAllRowsForKeyViaIndex, _getRow } from './OfflineMode';
import { getSafeString } from '@/helpers/commonFunctions';
import { NotificationCenter, NotificationType } from '@/assets/libraries/NotificationHandler';
import { useShowStore } from '@/stores/show';
import API from '@/assets/libraries/API_Requests';

export const saveRevision = function (show_object) {
	return new Promise((resolve, reject) => {
		if (show_object == undefined) {
			console.log('[Update DB Revision] Show_object can not be undefined');
			return reject();
		}

		show_object.revision_id = new Date().getTime();
		show_object.revision_saved_at = new Date().getTime();

		// show_object.revision_id = new Date().getTime() - 35 * 24 * 60 * 60 * 1000;
		// show_object.revision_saved_at = new Date().getTime() - 35 * 24 * 60 * 60 * 1000;
		if (isOffline() == true) {
			show_object.created_offline = true;
		}

		_updateRow('show_revisions', show_object)
			.then(() => {
				return resolve();
			})
			.catch((error) => {
				return reject(error);
			});
	});
};

const getMostRecentRevisionsForCurrentShow = function () {
	//Returns the 10 most recent revisions for the currently open show
	return new Promise(async (resolve, reject) => {
		if (useShowStore()?.active_show == undefined || useShowStore()?.active_show.show_ID == undefined) {
			return reject('NO SHOW CURRENTLY OPEN');
		}

		return getMostRecentRevisionsForShow(useShowStore()?.active_show.show_ID).then(resolve).catch(reject);
	});
};

const getMostRecentRevisionsForShow = function (show_id) {
	//Returns the 10 most recent revisions
	return new Promise((resolve, reject) => {
		if (show_id == undefined || null) {
			console.log('[Get most recent revisions for show] show_id can not be undefined');
			return reject();
		}

		_getAllRowsForKeyViaIndex('show_revisions', 'show_ID', show_id)
			.then((revisions) => {
				console.log('revisions', revisions);

				let sorted_revisions = revisions.sort((a, b) => b.revision_id - a.revision_id);
				let most_recent_revisions = sorted_revisions.slice(0, 10);
				console.log('most_recent_revisions', most_recent_revisions);

				return resolve(most_recent_revisions);
			})
			.catch((error) => {
				return reject(error);
			});
	});
};

const exportMostRecentRevisionsForCurrentShow = function () {
	//Exports the 10 most recent revisions for the currently open show
	return new Promise(async (resolve, reject) => {
		if (useShowStore()?.active_show == undefined || useShowStore()?.active_show.show_ID == undefined) {
			return reject('NO SHOW CURRENTLY OPEN');
		}

		return exportMostRecentRevisionsForShow(useShowStore()?.active_show.show_ID).then(resolve).catch(reject);
	});
};

const exportMostRecentRevisionsForShow = function (show_id) {
	//Exports the 10 most recent revisions
	return new Promise(async (resolve, reject) => {
		if (show_id == undefined || null) {
			console.log('[Export most recent revisions for show] show_id can not be undefined');
			return reject();
		}

		let most_recent_revisions = await getMostRecentRevisionsForShow(show_id).catch((error) => {
			console.error('[Export most recent revisions for show]Error getting most recent revisions for show', error);
			reject();
		});
		if (most_recent_revisions == undefined) {
			return reject();
		}

		await _downloadJSONFile(most_recent_revisions, `recent_revisions_for_${show_id}`).catch((error) => {
			console.error('[Export most recent revisions for show] Error downloading json', error);
		});
		return resolve();
	});
};

const exportRevisionToJSON = function (revision_id) {
	return new Promise(async (resolve, reject) => {
		if (revision_id == undefined || null) {
			console.log('[Export DB Revision to JSON] revision_id can not be undefined');
			return reject();
		}

		_getRow('show_revisions', revision_id)
			.then(async (revision) => {
				// console.log('revision',revision);

				if (revision == undefined) {
					console.log('[Export DB Revision to JSON] Invalid revision_id.');
					return reject('INVALID_REVISION_ID');
				}

				await _downloadJSONFile(revision, `revision_${getSafeString(revision_id).toLowerCase().trim()}`).catch((error) => {
					console.error('Error downloading json', error);
				});

				return resolve();
			})
			.catch((error) => {
				return reject(error);
			});
	});
};

const uploadRevision = function (revision_id) {
	return new Promise(async (resolve, reject) => {
		if (revision_id == undefined || null) {
			console.log('[Upload Revision] revision_id can not be undefined');
			return reject();
		}

		_getRow('show_revisions', revision_id)
			.then(async (revision) => {
				// console.log('revision',revision);

				if (revision == undefined) {
					console.log('[Upload Revision] Invalid revision_id.');
					return reject('INVALID_REVISION_ID');
				}

				await _uploadRevision(revision)
					.then(() => {
						return resolve();
					})
					.catch((error) => {
						console.error('Error uploading revision', error);
						return reject(error);
					});
			})
			.catch((error) => {
				return reject(error);
			});
	});
};

const uploadMostRecentRevisionsForCurrentShow = function () {
	//Exports the 10 most recent revisions for the currently open show
	return new Promise(async (resolve, reject) => {
		if (useShowStore()?.active_show == undefined || useShowStore()?.active_show.show_ID == undefined) {
			return reject('NO SHOW CURRENTLY OPEN');
		}

		return uploadMostRecentRevisionsForShow(useShowStore()?.active_show.show_ID).then(resolve).catch(reject);
	});
};

const uploadMostRecentRevisionsForShow = function (show_id) {
	return new Promise(async (resolve, reject) => {
		if (show_id == undefined || null) {
			console.log('[Upload most recent revisions for show] show_id can not be undefined');
			return reject();
		}

		let most_recent_revisions = await getMostRecentRevisionsForShow(show_id).catch((error) => {
			console.error('[Upload most recent revisions for show] Error getting most recent revisions for show', error);
			reject();
		});
		if (most_recent_revisions == undefined) {
			return reject();
		}

		await _uploadRevision(most_recent_revisions)
			.then(() => {
				return resolve();
			})
			.catch((error) => {
				console.error('[Upload most recent revisions for show] Error uploading revision', error);
				return reject(error);
			});
	});
};

const _downloadJSONFile = function (json = {}, file_name) {
	return new Promise(async (resolve, reject) => {
		try {
			var json_blob = new Blob([JSON.stringify(json)], { type: 'application/json' });
			var json_blob_url = URL.createObjectURL(json_blob);

			var a_tag = document.createElement('a');
			document.body.appendChild(a_tag);
			a_tag.style = 'display: none';
			a_tag.href = json_blob_url;
			a_tag.download = file_name;
			a_tag.click();
			window.URL.revokeObjectURL(json_blob_url);
			document.body.removeChild(a_tag);

			return resolve();
		} catch (error) {
			return reject(error);
		}
	});
};

const _uploadRevision = function (json) {
	return new Promise(async (resolve, reject) => {
		if (json == undefined || null) {
			console.log('[Upload Revision] json can not be undefined');
			return reject();
		}

		API.Call('POST', `${API.CSC_API_URL}/shows/history`, { revision_json: json })
			.then((response) => {
				if (response.error != undefined) {
					switch (response.error.title) {
						case 'NO_NETWORK_CONNECTION':
							break;
						case 'INVALID_PERMISSIONS':
							// showBanner("This account does not have permissions to edit this show.", "error");
							NotificationCenter.add(new Notification('Invalid Permission', 'This account does not have permissions to edit this show.', [], NotificationType.ERROR, { expire_time: 20000 }));
							// showSaveMessage('Error saving');
							break;
						default:
							NotificationCenter.add(new Notification('Saving Show Status', 'Due to current maintenance, your show has not been saved to the cloud. It has been saved locally and will be uploaded once the maintenance window is over.', [], NotificationType.INFO, { expire_time: 15000 }));
						// showSaveMessage('Saved locally at ', true); //true will insert the current time at the end.
					}
				}

				console.log('successfully uploaded', response);
			})
			.catch(() => {
				NotificationCenter.add(new Notification('Saving Show Status', 'Due to current maintenance, your show has not been saved to the cloud. It has been saved locally and will be uploaded once the maintenance window is over.', [], NotificationType.INFO, { expire_time: 15000 }));
				// showSaveMessage('Saved locally at ', true); //true will insert the current time at the end.
			});
	});
};

window.saveRevision = saveRevision;
window.getMostRecentRevisionsForCurrentShow = getMostRecentRevisionsForCurrentShow;
window.getMostRecentRevisionsForShow = getMostRecentRevisionsForShow;
window.exportMostRecentRevisionsForCurrentShow = exportMostRecentRevisionsForCurrentShow;
window.exportMostRecentRevisionsForShow = exportMostRecentRevisionsForShow;
window.exportRevisionToJSON = exportRevisionToJSON;
window.uploadRevision = uploadRevision;
window.uploadMostRecentRevisionsForCurrentShow = uploadMostRecentRevisionsForCurrentShow;
window.uploadMostRecentRevisionsForShow = uploadMostRecentRevisionsForShow;
window._downloadJSONFile = _downloadJSONFile;
window._uploadRevision = _uploadRevision;
